export const padaitem = [
      {
        "anio" : "Reglas de Operación del Grupo Interdisciplinario de Archivo ",
        "url": "/pdf/ReglasdeOperacion_GIA_2026.pdf"
    },
    
    
    {
        "anio" : "PADA 2026",
        "url": "/pdf/PADA2026.pdf"
    },
     {
        "anio" : "PADA 2025",
        "url": "/pdf/PADA2025.pdf"
    },
    
]